import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
import LogoS from '../../../assets/images/logo-a.png'
import './index.scss'

const Logo = () => {
  const bgRef = useRef()
  const outlineLogoRef = useRef()
  const solidLogoRef = useRef()

  useEffect(() => {
    gsap.registerPlugin(DrawSVGPlugin)

    gsap
      .timeline()
      .to(bgRef.current, {
        duration: 1,
        opacity: 1,
      })
      .from(outlineLogoRef.current, {
        drawSVG: 0,
        duration: 4,
      })

    gsap.fromTo(
      solidLogoRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        delay: 3.5,
        duration: 3,
      }
    )
  }, [])

  return (
    <div className="logo-container" ref={bgRef}>
      <img
        className="solid-logo"
        ref={solidLogoRef}
        src={LogoS}
        alt="JavaScript,  Developer"
      />

      <svg
        width="1553pt"
        height="1986pt"
        version="1.0"
        viewBox="0 0 1553 1986"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          className="svg-container"
          transform="translate(0 1986) scale(.1 -.1)"
          fill="none"
        >
          <path
            ref={outlineLogoRef}
            d="M6431 19673 c-70 -247 -147 -488 -165 -516 -8 -12 -22 -51 -31 -87 -9 -36 -46 -166 -82 -290 -36 -124 -87 -301 -113 -395 -92 -325 -172 -602 -255 -890 -47 -159 -114 -391 -149 -515 -113 -395 -164 -572 -201 -700 -20 -69 -44 -154 -55 -190 -10 -36 -60 -209 -110 -385 -51 -176 -118 -410 -150 -520 -32 -110 -103 -357 -158 -550 -115 -401 -157 -545 -254 -880 -38 -132 -103 -355 -143 -495 -40 -140 -126 -435 -190 -655 -64 -220 -132 -456 -151 -525 -20 -69 -55 -190 -79 -270 -24 -80 -62 -208 -83 -285 -44 -156 -325 -1131 -397 -1380 -26 -88 -65 -223 -86 -300 -22 -77 -80 -277 -129 -445 -49 -168 -125 -431 -169 -585 -140 -491 -171 -596 -217 -760 -25 -88 -75 -257 -110 -375 -35 -118 -92 -316 -128 -440 -35 -124 -103 -360 -151 -525 -48 -165 -105 -363 -127 -440 -21 -77 -56 -198 -77 -270 -22 -71 -58 -197 -81 -280 -23 -82 -57 -199 -75 -260 -19 -60 -104 -355 -190 -655 -86 -300 -176 -612 -200 -695 -24 -82 -71 -244 -104 -360 -33 -115 -92 -320 -131 -455 -76 -260 -335 -1160 -445 -1545 -36 -126 -93 -322 -127 -435 -33 -113 -80 -275 -104 -360 -24 -85 -52 -184 -64 -220 -11 -35 -16 -68 -12 -72 10 -10 2423 -2 2818 9 209 6 285 11 297 21 17 14 64 152 121 352 152 540 215 758 261 905 29 94 79 260 110 370 32 110 79 268 105 350 27 83 74 236 105 340 61 204 117 372 139 420 8 17 31 84 50 150 20 66 65 217 100 335 l64 215 3105 3 3104 2 32 -107 c18 -60 59 -196 93 -303 33 -107 82 -269 110 -360 27 -91 85 -280 128 -420 43 -140 115 -376 160 -525 45 -148 111 -362 146 -475 103 -333 228 -743 284 -925 28 -93 66 -213 83 -265 l32 -95 1110 1 c611 0 1297 3 1525 7 228 3 430 6 448 7 29 0 32 3 32 29 0 17 -4 32 -9 35 -4 3 -23 56 -41 118 -42 147 -183 627 -277 943 -41 138 -126 425 -189 638 -63 214 -128 430 -144 480 -16 51 -56 189 -90 307 -34 118 -88 303 -120 410 -32 107 -99 335 -150 505 -84 283 -161 541 -314 1055 -30 102 -76 258 -101 348 -25 90 -74 256 -109 370 -64 208 -119 395 -219 747 -79 279 -263 909 -382 1310 -57 193 -143 487 -190 655 -48 168 -122 424 -165 570 -43 146 -96 328 -118 405 -78 277 -429 1483 -534 1840 -39 132 -92 317 -118 410 -26 94 -70 247 -98 340 -28 94 -75 258 -105 365 -31 107 -87 305 -127 440 -117 400 -177 607 -275 950 -108 377 -228 789 -325 1115 -38 127 -92 315 -120 419 -28 105 -74 264 -102 355 -27 91 -97 328 -154 526 -151 526 -283 980 -357 1230 -36 121 -91 312 -122 425 -31 113 -104 367 -162 565 -57 198 -142 494 -188 659 -47 164 -105 368 -130 452 -25 85 -45 157 -45 159 0 3 -773 5 -1718 5 l-1718 0 -53 -187z m1825 -5176 c29 -100 91 -317 139 -482 48 -165 109 -379 136 -475 28 -96 81 -281 119 -410 38 -129 107 -368 154 -530 47 -162 106 -365 131 -450 25 -85 83 -285 129 -445 80 -275 129 -444 315 -1085 109 -377 158 -548 256 -880 182 -617 352 -1204 415 -1430 21 -74 69 -241 108 -370 38 -129 86 -291 105 -360 20 -69 39 -133 42 -142 6 -15 -31 -17 -512 -22 -285 -3 -1233 -8 -2106 -11 -1467 -5 -1588 -4 -1594 11 -7 18 13 96 73 299 34 114 61 210 203 720 34 121 93 326 131 455 38 129 110 379 161 555 50 176 133 464 184 640 51 176 174 606 274 955 100 349 210 732 246 850 35 118 84 289 109 380 80 292 176 603 212 690 38 92 76 213 147 465 25 88 89 311 142 495 53 184 124 433 158 553 33 119 63 214 66 211 3 -3 29 -87 57 -187z"
          />
        </g>
      </svg>
    </div>
  )
}

export default Logo
